import { useEffect, useState } from "react";
import { isHotkeyPressed } from "react-hotkeys-hook";
import classNames from "classnames";

import Emojify from "~/components/shared/Emojify";
import { CommandItem } from "~/components/shared/Command";
import { isIgnored, Step, labelForStep } from "~/lib/pipeline";

export function StepSearchItem({
  step,
  onSelect,
}: {
  step: Step;
  onSelect: (currentValue: string) => void;
}) {
  const [shiftPressed, setShiftPressed] = useState(false);

  useEffect(() => {
    function callback() {
      setShiftPressed(isHotkeyPressed("shift"));
    }

    document.addEventListener("keydown", callback);
    document.addEventListener("keyup", callback);

    return () => {
      document.removeEventListener("keydown", callback);
      document.removeEventListener("keyup", callback);
    };
  }, []);

  // Skipped (ignored) steps are still findable, but crossed out to match how
  // they're rendered in the step list.
  const stepIsIgnored = isIgnored(step);

  return (
    <CommandItem
      className={classNames("group", { "opacity-45": stepIsIgnored })}
      key={step.uuid}
      value={step.uuid}
      onSelect={onSelect}
    >
      <Emojify
        text={labelForStep(step)}
        className={classNames("truncate", { "line-through": stepIsIgnored })}
      />

      <span className="ml-auto whitespace-nowrap text-xs group-data-[selected=false]:hidden">
        {shiftPressed ? "Focus step" : "Go to step"}
      </span>
    </CommandItem>
  );
}
